module.exports = __webpack_public_path__ + "img/topimg.d0f11675.png";